import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DashedCornerTopLeft from "@default/assets/ui/dashed-corner-top-left.svg?url";
import DashedCornerTopRight from "@default/assets/ui/dashed-corner-top-right.svg?url";
import DashedCornerBottomLeft from "@default/assets/ui/dashed-corner-bottom-left.svg?url";
import DashedCornerBottomRight from "@default/assets/ui/dashed-corner-bottom-right.svg?url";

const DashedCorners = ({ modifier }) => (
  <div className="dashed-corner-wrapper">
    {modifier === "bigger" ? (
      <>
        <img
          className={classNames("dashed-corner top left", modifier)}
          src={DashedCornerTopLeft}
          alt=""
        />
        <img
          className={classNames("dashed-corner top right", modifier)}
          src={DashedCornerTopRight}
          alt=""
        />
        <img
          className={classNames("dashed-corner bottom left", modifier)}
          src={DashedCornerBottomLeft}
          alt=""
        />
        <img
          className={classNames("dashed-corner bottom right", modifier)}
          src={DashedCornerBottomRight}
          alt=""
        />
      </>
    ) : (
      <>
        <div className={classNames("dashed-corner top left", modifier)} />
        <div className={classNames("dashed-corner top right", modifier)} />
        <div className={classNames("dashed-corner bottom left", modifier)} />
        <div className={classNames("dashed-corner bottom right", modifier)} />
      </>
    )}
  </div>
);

DashedCorners.propTypes = {
  modifier: PropTypes.string,
};

export default DashedCorners;
